import formatAsCurrency from '../../CommonUtils/formatAsCurrency';

const assumptions = [
  {
    title: 'Annual Cost',
    key: 'AnnualCost',
    template: ({ EstimateExpenses, AnnualCost }) => {
      if (EstimateExpenses) {
        return 'Automatically Estimate';
      }
      return formatAsCurrency(AnnualCost);
    },
  },
  {
    title: 'Goal Start Year',
    key: 'GoalStartYear',
    template: ({ AtRetirement, Year }) => {
      if (AtRetirement) {
        return 'At retirement';
      }
      return Year;
    },
  },
  {
    title: 'Inflation Rate',
    key: 'InflationRate',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    title: 'Additional Savings',
    key: 'AdditionalSavings',
    template: value => formatAsCurrency(value),
  },
  {
    title: 'Asset Allocation',
    key: 'AssetAllocation',
    template: value => value,
  },
  {
    title: 'Rate of Return',
    key: 'RateOfReturn',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    title: 'Earmarked Assets',
    key: 'EarmarkedAssets',
    template: value => `Total Earmarked toward this goal ${formatAsCurrency(value)}`,
  },
];

export default assumptions;
